import { MiddlewareStore } from "store/createStore";
import { ChatMessageEvent, IChatMessage } from "store/messages/messages.state";

export const handleChatEnded = async (message: IChatMessage, store: MiddlewareStore) => {
    if (message.contentType !== ChatMessageEvent.CHAT_ENDED) return message;

    const storeMessages = [...store.getState().messages];

    if (storeMessages.pop()?.contentType === ChatMessageEvent.CHAT_ENDED) {
        message.discarded = true;
    };


    return message;
}